import { AbstractControl, ValidatorFn } from "@angular/forms";
import { CPR } from "../models/cpr";

export function cprValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const cpr = new CPR(control.value);
    return cpr.validityStatus.valid === true ? null : cpr.validityStatus;
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/cpr-validator.directive.ts